import React from 'react';
import WidgetItem from '../../widget-grid/jsx/WidgetItem';

export default function EmailsListingLoadingState({ title, numOfItems = 4 }) {
    return (
        <WidgetItem title={title} className="no-wysiwyg emails-listing">
            <div className="sr-only">Loading...</div>
            <ol className="emails-list">
                {[...Array(numOfItems)].map((item, index) => (
                    <li
                        className="emails-list__item emails-list--loading"
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                    />
                ))}
            </ol>
        </WidgetItem>
    );
}
